export const PORTFOLIO_BUILDER_HANDOFF_COMPLETED_STATE_KEY = 'portfolio-builder-handoff-complete';

const PORTFOLIO_BUILDER_HANDOFF_COMPLETED_STORAGE_PREFIX = 'portfolioBuilderHandoffCompleted';

export function getPortfolioBuilderHandoffCompletedStorageKey(
	userUuid: string | undefined
): string | undefined {
	return userUuid ? `${PORTFOLIO_BUILDER_HANDOFF_COMPLETED_STORAGE_PREFIX}:${userUuid}` : undefined;
}
